<!-- <div>
    <div>
        <div class="form-title">
            <span class="subtitle">{{listTitle}}</span>
            <ng-container *ngIf="showList;else hideList">
                <div class="rollup-down">
                    <nb-icon class="arrowhead" icon="arrowhead-up-outline" #resultsChevron (click)="toggleIcon()"></nb-icon>
                </div>
            </ng-container>
            <ng-template #hideList>
                <div class="rollup-down">
                    <nb-icon class="arrowhead" icon="arrowhead-down-outline" #resultsChevron (click)="toggleIcon()"></nb-icon>
                </div>
            </ng-template>
        </div>
        <div>
            <p>Eum suscipit similique. Magni excepturi sapiente quibusdam cumque. Non repellendus optio molestias ea cumque aut eos eaque occaecati. Optio tempora dolor et iusto voluptatem architecto dolor consequatur. Qui fuga corporis.land seizures</p>
 
            <p>Ipsum doloremque corrupti voluptas sunt enim deserunt est architecto saepe. Quidem exercitationem consequatur dolor dignissimos doloribus. Suscipit consectetur in id.</p>
 
                <p>Veniam magnam excepturi dolorum vel et. Repellendus dignissimos aut. Culpa quam omnis quia saepe.</p>
        </div>
    </div>
</div> -->
<!-- <div class="display-container scrollable-container"> -->
    <iframe [src]="iframeUrl" #iframe (load)="onIframeLoad()">
        
    </iframe>
<!--     <ng-container *ngIf="(editState === 'editing' || editState === 'updated');else loading">
        <iframe src="http://localhost:4200/preview" #iframe (load)="onLoad(iframe)">
        
        </iframe>
    </ng-container>
    <ng-template #loading>
        <div class="loading-container">
            <div>Loading</div>
        </div>
    </ng-template> -->
    
<!-- </div> -->


